// Mobile floating add-to-cart bar. Mirrors price + quantity from the inline
// product form and shows itself whenever the real Add-to-cart button is off-screen.
if (!customElements.get('sticky-atc')) {
	customElements.define(
		'sticky-atc',
		class StickyAtc extends HTMLElement {
			connectedCallback() {
				// A transformed ancestor would trap position:fixed, so pin to <body>.
				// Re-parenting re-fires connectedCallback; the guard lets it run once.
				if (this.parentElement !== document.body) {
					document.body.appendChild(this);
					return;
				}

				this.realForm = document.getElementById(this.dataset.formId);
				this.realPrice = document.getElementById(this.dataset.priceId);
				this.realQty = document.getElementById(this.dataset.qtyId);
				this.realSubmit = document.getElementById(this.dataset.submitId);
				this.priceEl = this.querySelector('[data-sticky-price]');
				this.qtyEl = this.querySelector('[data-sticky-qty]');
				this.addBtn = this.querySelector('[data-sticky-add]');
				if (!this.realSubmit || !this.addBtn) return;

				// Mirror price, keeping it correct across variant changes.
				this.syncPrice();
				if (this.realPrice) {
					new MutationObserver(() => this.syncPrice()).observe(this.realPrice, {
						childList: true,
						subtree: true,
						characterData: true,
					});
				}

				// Two-way quantity sync so either stepper drives the same cart quantity.
				if (this.qtyEl && this.realQty) {
					this.qtyEl.value = this.realQty.value;
					this.qtyEl.addEventListener('change', () => {
						this.realQty.value = this.qtyEl.value;
						this.realQty.dispatchEvent(new Event('change', { bubbles: true }));
					});
					this.realQty.addEventListener('change', () => {
						this.qtyEl.value = this.realQty.value;
					});
				}

				// Reuse the real form's submit logic.
				this.addBtn.addEventListener('click', () => this.realSubmit.click());
				this.syncSubmitState();
				new MutationObserver(() => this.syncSubmitState()).observe(this.realSubmit, {
					attributes: true,
					childList: true,
					subtree: true,
				});

				// Show the bar whenever the inline buy area is fully off-screen —
				// before reaching it and after scrolling past it.
				const target = this.realForm || this.realSubmit;
				new IntersectionObserver(([entry]) => {
					const show = !entry.isIntersecting;
					this.classList.toggle('is-visible', show);
					// Tell the scroll-to-top button how far to lift (see sticky-atc.css).
					if (show) document.body.style.setProperty('--sticky-atc-h', `${this.offsetHeight}px`);
					document.body.classList.toggle('sticky-atc-visible', show);
				}).observe(target);
			}

			syncPrice() {
				if (this.realPrice && this.priceEl) this.priceEl.innerHTML = this.realPrice.innerHTML;
			}

			syncSubmitState() {
				this.addBtn.disabled = this.realSubmit.disabled;
				const label = this.realSubmit.querySelector('span');
				const target = this.addBtn.querySelector('span');
				if (label && target) target.textContent = label.textContent;
			}
		},
	);
}
